import { _, $, Backbone, Radio, Foundation } from "../../vendor";
import { Dependencies } from "../utils";

import InboomaBaseController from "./InboomaBaseController";

import VoucherType from "../models/VoucherType";

import VoucherTypesView from "../views/vouchers/VoucherTypesView";
import VoucherTypesSidebarView from "../views/vouchers/VoucherTypesSidebarView";
import VoucherTypesSortTabsView from "../views/vouchers/VoucherTypesSortTabsView";
import OffCanvasVouchersForm from "../views/vouchers/OffCanvasVouchersForm";
import VouchersExportView from "../views/vouchers/VouchersExportView";
import VoucherTypesTpl from "../templates/vouchers/VoucherTypesTpl.html";
import Vouchers from "../collections/Vouchers";
import Contingents from "../collections/Contingents";
import { isViewVisible } from "../utils/ViewSettings";
import OrdersExportView from "../views/orders/OrdersExportView";

export default InboomaBaseController.extend({
  _el: "#inb-c-main-voucher-types",
  _channelName: "voucherTypes",
  _template: VoucherTypesTpl,

  _accessBarMap() {
    return {
      model: VoucherType,
      collection: this.collection,
      pageTitle: this.t("vouchers", null, "capital"),
      searchPlaceholder: this.t("vouchers") + " / ID ",
      linksMap: {
        tab_discount: {
          url: "/vouchers",
          icon: "fi fi-address-book",
          isAccessible: isViewVisible("vouchers"),
        },
        tab_gift_card: {
          url: "/vouchers/gift-cards",
          icon: "fi fi-torsos-all",
          isAccessible: isViewVisible("vouchers"),
        },
      },
    };
  },

  _getCurrentType(type) {
    let routeTypesMap = {
      "gift-cards": "gift_card",
      null: "discount",
    };

    return routeTypesMap[type] ? routeTypesMap[type] : routeTypesMap[null];
  },

  index(type = null) {
    this._resetOptions(type);

    type = this._getCurrentType(type);

    if (
      typeof this.voucherTypesView !== "undefined" &&
      typeof this.voucherTypesView.unbindEvents == "function"
    ) {
      this.voucherTypesView.$el.empty();
      this.voucherTypesView.stopListening();
    }

    this.accessBar.changeActiveLink("tab_" + type);

    this.collection.resetFilters();

    this.voucherTypesView = new VoucherTypesView({
      collection: this.collection,
      widgetMode: this.widgetMode,
      el: this.el,
      type: type,
    });

    if (!this.widgetMode) {
      this.sidebarView = new VoucherTypesSidebarView({
        collection: this.collection,
        model: VoucherType,
      });
      this.SortTabsView = new VoucherTypesSortTabsView({
        collection: this.collection,
        model: VoucherType,
      });
    }
  },

  giftCards() {
    this.index("gift-cards");
  },
  vouchersExport(vtId = null) {
    this.index();

    let model = null;
    let requestObject = new VoucherType({ id: vtId });

    requestObject.fetch({
      async: false,
      success: (responseModel, response) => {
        model = responseModel;
      },
    });
    if (typeof model !== "undefined") {
      new Dependencies({
        vouchers: new Vouchers(),
      }).then(() => {
        const vouchersExportView = new VouchersExportView({
          model,
          collection: this._collection,
        });
      });
    } else {
      alert(this.t("unknown_or_removed_voucher"));
    }
    //const vouchersExportView = new VouchersExportView();
  },
  vouchersForm(id = null) {
    this.index();

    let model = null;

    if (id === null || id == "") {
      model = new VoucherType();
    } else {
      let requestObject = new VoucherType({ id: id });

      requestObject.fetch({
        async: false,
        success: (responseModel, response) => {
          model = responseModel;
        },
      });
    }

    if (typeof model !== "undefined") {
      new Dependencies({
        vouchers: new Vouchers(),
      }).then(() => {
        const offCanvasVouchersForm = new OffCanvasVouchersForm({
          model,
          collection: this._collection,
        });
      });
    } else {
      alert(this.t("unknown_or_removed_voucher"));
    }
  },
});
